// @flow

import _ from 'lodash';

import adjustUrlParams from './adjustUrlParams';
import isEmptyString from './utils/isEmptyString';

type ParamsType = { [string]: ?(string | number | boolean) };

const sanitize = (params, onlyTruthyParams) =>
  onlyTruthyParams ? _.omitBy(params, isEmptyString) : params;

const addParamsToUrl = (
  url: string,
  params: ParamsType = {},
  onlyTruthyParams: boolean = false
): string =>
  adjustUrlParams(
    currentParams => ({
      ...currentParams,
      ...sanitize(params, onlyTruthyParams),
    }),
    url
  );

export default addParamsToUrl;
